module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "goods-wrap",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.skuImages), function(img, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('imgs', {
      attrs: {
        "width": 700,
        "imagePath": img && img.imagePath && img.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-custom",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-content"
  }, [_c('div', {
    staticClass: "goods-box"
  }, [_c('span', {
    staticClass: "goodsName"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName || ""))]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "diy-button",
    attrs: {
      "label": "DIY",
      "primary": ""
    },
    on: {
      "click": _vm.gotoDIY
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [_c('span', {
    staticClass: "price floatL"
  }, [_vm._v("\n            优惠价\n            "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && (_vm.goodsSkuMsg.sku.goodsPrice > 0 ? _vm.goodsSkuMsg.sku.goodsPrice : _vm.goodsSkuMsg.sku.priceDesc)))])]), _vm._v(" "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice > 0) ? _c('span', {
    staticClass: "price old-price floatR"
  }, [_vm._v("\n            原价 "), _c('dd', [_vm._v("￥" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice || 0.00))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips saleNum"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("销量：" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.saleNum || 0) + "件")]), _vm._v(" "), _c('span', {
    staticClass: "floatR"
  }, [_vm._v("库存：" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.stockNum || 0) + "件")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuDesc || ""))])]), _vm._v(" "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons.length > 0) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "button coupon-box",
    on: {
      "click": function($event) {
        _vm.couponPopup = true
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = true
      }
    }
  }, [_c('span', [_c('samp', [_vm._v("已选")]), _vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuFields || ""))])]), _vm._v(" "), _c('div', {
    staticClass: "store-map"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('samp', [_vm._v("门店")]), _vm._v(" "), _c('div', {
    staticClass: "verticalM-box address"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = true
      }
    },
    model: {
      value: (_vm.addressMsgShow),
      callback: function($$v) {
        _vm.addressMsgShow = $$v
      },
      expression: "addressMsgShow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.addressMsgShow) + "\n            ")])])]), _vm._v(" "), (_vm.amap) ? _c('div', {
    staticClass: "map-box map"
  }, [_c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo",
      "center": _vm.amap.center,
      "map-manager": _vm.amap.amapManager,
      "zoom": _vm.amap.zoom,
      "events": _vm.amap.events
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.gotoEvalute
    }
  }, [_c('span', [_c('samp', [_vm._v("评价")]), (_vm.GoodsComm.favRate) ? _c('label', [_vm._v("好评率" + _vm._s(_vm.GoodsComm.favRate) + "%")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "floatR show-evalute"
  }, [_vm._v("查看全部评价")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluate-detail"
  }, [_c('div', {
    staticClass: "evaluate-label"
  }, _vm._l((_vm.GoodsComm.commentTags), function(tag) {
    return _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(tag.name)), _c('samp', [_vm._v(_vm._s(tag.nums))])])
  }), 0), _vm._v(" "), (_vm.GoodsCommList.length < 1) ? _c('p', {
    staticClass: "none-conment"
  }, [_vm._v("对不起，暂时没有找到结果")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsCommList), function(item) {
    return _c('div', {
      staticClass: "evaluate-item"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('imgs', {
      attrs: {
        "imagePath": item.header && item.header.imagePath
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.memName))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v(_vm._s(item.commTime))])]), _c('div', {
      staticClass: "floatR"
    }, _vm._l((5), function(i) {
      return _c('span', {
        staticClass: "star",
        class: {
          active: i <= Math.floor(item.starScore)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.commDesc))]), _vm._v(" "), (item.replyDesc) ? _c('div', {
      staticClass: "merchant-reply"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v("美心商城回复:")]), _vm._v(" "), _c('span', {
      staticClass: "floatR time"
    }, [_vm._v(_vm._s(item.replyTime))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.replyDesc))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tripartite-box",
    style: (_vm.txtStyle)
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n          " + _vm._s(_vm.tip) + "\n        ")])])], 2), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "custom-popup-bottom flex-column",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-img"
  }, [_c('imgs', {
    attrs: {
      "width": 200,
      "imagePath": _vm.skuImages && _vm.skuImages[0] && _vm.skuImages[0].imagePath && _vm.skuImages[0].imagePath.imagePath
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('p', {
    staticClass: "price"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.goodsPrice || 0.00))]), _vm._v(" "), _c('p', {
    staticClass: "desc overflowT2"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName || ""))])])]), _vm._v(" "), _vm._l(((_vm.goodsSkuMsg && _vm.goodsSkuMsg.fields)), function(item) {
    return _c('div', {
      staticClass: "goods-label"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
      staticClass: "label-list"
    }, _vm._l((item.values), function(value) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: value.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectSku(item.fieldId, value.valueId)
          }
        }
      }, [_vm._v(_vm._s(value.valueName))])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-number"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("件")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-receive-popup-bottom flex-column",
      "open": _vm.couponPopup
    },
    on: {
      "close": function($event) {
        _vm.couponPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n                领券\n              ")]), _vm._v(" "), _c('emptyCart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons.length <= 0),
      expression: "goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.coupons && goodsSkuMsg.sku.coupons.length<=0"
    }],
    attrs: {
      "emptytext": "当前店铺没有优惠券了~"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "coupon-list-item"
  }, _vm._l((_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons), function(couponItem) {
    return _c('tr', [_c('td', [(couponItem.couponCate != 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2
      }
    }, [_vm._v("￥" + _vm._s(couponItem.couponAmount))]) : _vm._e(), _vm._v(" "), (couponItem.couponCate == 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2
      }
    }, [_vm._v(_vm._s(_vm._f("discount")(couponItem.couponDiscount))), _c('samp', [_vm._v("折")])]) : _vm._e()]), _vm._v(" "), _c('td', [(couponItem.couponType == 1) ? _c('p', [_vm._v(_vm._s(couponItem.useAmount == 0 ? '不限制' : '满' + couponItem.useAmount + '可用'))]) : _vm._e(), _vm._v(" "), (couponItem.couponType == 2) ? _c('p', [_vm._v("剩余" + _vm._s((parseInt(couponItem.sendNum) - parseInt(couponItem.recivedNum))) + "个红包")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(couponItem.effectiveTime) + " - " + _vm._s(couponItem.overdueTime))])]), _vm._v(" "), _c('td', [(couponItem.isGet == 1) ? _c('button', {
      staticClass: "gray finish",
      attrs: {
        "type": "default",
        "disabled": ""
      }
    }, [_vm._v("已领取")]) : _vm._e(), _vm._v(" "), (couponItem.isGet == 0) ? _c('button', {
      staticClass: "gray",
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          return _vm.getCoupon(couponItem.couponId, couponItem.couponType, couponItem.isGet)
        }
      }
    }, [_vm._v("领取")]) : _vm._e()])])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "popup-bottom physical-popup",
      "open": _vm.addressPopup
    },
    on: {
      "close": function($event) {
        _vm.addressPopup = false
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.isAddress ? '所在地区' : '选择品牌')), _c('span', {
    on: {
      "click": function($event) {
        _vm.addressPopup = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [(_vm.isAddress) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.adressFirm
    }
  })], 1)])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-title"
  }, [_c('span', [_c('samp', [_vm._v("领券优惠")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item redpackage"
  }, [_c('span', [_vm._v("红包")])]), _vm._v(" "), _c('label', [_vm._v("领取红包")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item coupon"
  }, [_c('span', [_vm._v("优惠券")])]), _vm._v(" "), _c('label', [_vm._v("领取优惠券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7594a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classify/goods.vue
// module id = 406
// module chunks = 68